/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';

const staticCss = css`
  margin: 0;
`;

export const CardTitle = ({ children, ...rest }) => (
  <h4 {...rest} css={staticCss}>
    {children}
  </h4>
);

CardTitle.propTypes = {
  children: PropTypes.node,
};
CardTitle.defaultProps = {
  children: null,
};
